import * as React from 'react';
import { SVGProps } from 'react';

const DollarToggleDeactiveIcon = ({
  width = 10,
  height = 14,
}: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    data-palette="DollarToggleDeactiveIcon">
    <path
      fill="#5A606B"
      d="M1.111 8.889h6.111a.556.556 0 1 0 0-1.111H2.778a2.778 2.778 0 1 1 0-5.556h1.11V0h2.223v2.222H8.89v2.222H2.778a.556.556 0 0 0 0 1.112h4.444a2.778 2.778 0 0 1 0 5.555h-1.11v2.222H3.888v-2.222H1.11V8.89Z"
    />
  </svg>
);
export default DollarToggleDeactiveIcon;
